import { useEffect, useRef, useCallback } from 'react';
import throttle from 'lodash/throttle';
import UserInfo from '../UserInfo';

export const useIdleTimer = ({ enable, onIdle, timeout }) => {
    const timeoutId = useRef();

    const resetTimer = () => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(() => {
            localStorage.setItem("lastPageView", document.location.pathname)
            localStorage.setItem("lastInstanceId", String(UserInfo.instanceId))
            localStorage.setItem("logoutType", "inactivity")
            onIdle()
        }, timeout);
    };

    const throttleHandler = throttle(() => {
        resetTimer();
    }, 1000, { leading: true, trailing: false })

    const handleEvent = useCallback(throttleHandler, []);

    useEffect(() => {
        if (!enable) return;

        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];

        resetTimer();

        events.forEach(event => {
            window.addEventListener(event, handleEvent);
        });

        return () => {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
            events.forEach(event => {
                window.removeEventListener(event, handleEvent);
            });
        };
    }, [onIdle, timeout]);

    return { timeoutId };
};